// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { useMemo } from "react";

export type BreakpointOption = DataOption<BreakpointKey>;
export interface BreakpointOptionMapper {
    xs: BreakpointOption;
    sm: BreakpointOption;
    md: BreakpointOption;
    lg: BreakpointOption;
    xl: BreakpointOption;
}
export type BreakpointOptions = DataOptions<BreakpointOption> & BreakpointOptionMapper;

export const breakpointOptions: BreakpointOptions = {
    xs: { id: "xs", displayName: "Mobile (XS)" },
    sm: { id: "sm", displayName: "Portrait Tablet (SM)" },
    md: { id: "md", displayName: "Landscape Tablet (MD)" },
    lg: { id: "lg", displayName: "Small Desktop (LG)" },
    xl: { id: "xl", displayName: "Desktop (XL)" },
};

export type BreakpointFieldValue = BreakpointKey | undefined;
export interface BreakpointFieldOptions {
    isChildDefinition?: boolean;
}

export const getBreakpointFieldData = (value: BreakpointFieldValue) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(breakpointOptions, value);
};

export const getBreakpointFieldDefinition = (name: string, options?: BreakpointFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(breakpointOptions),
        name,
        displayName: "Breakpoint",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
    };

    return definition;
};

const getBreakpointField = (name: string, options?: BreakpointFieldOptions) => {
    const parse = (value: BreakpointFieldValue) => getBreakpointFieldData(value);

    return {
        definition: getBreakpointFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getBreakpointField;
